import { Drawer, Layout } from "antd";
import { LayoutContext } from "../../../context/LayoutContext";
import { useContext } from "react";
import "./CommonLayout.css";
import CustomSider from "./CustomSider";
const { Content } = Layout;

const CommonLayout = ({ children }) => {
    const { collapsed, isMobile, setCollapsed } = useContext(LayoutContext);

    const getMarginLeft = () => {
        if (!isMobile) {
            return !collapsed ? 200 : 75;
        }
        return 0;
    };

    return (
        <Layout
            style={{
                minHeight: "100vh",
            }}
        >
            {isMobile ? (
                <Drawer
                    open={!collapsed}
                    onClose={() => setCollapsed(true)}
                    placement="left"
                >
                    <CustomSider />
                </Drawer>
            ) : (
                <CustomSider />
            )}
            <Layout className="site-layout">
                <Content
                    style={{
                        marginLeft: getMarginLeft(),
                    }}
                >
                    <div
                        className="site-layout-background"
                        style={{
                            padding: isMobile ? 0 : 24,
                            minHeight: 360,
                        }}
                    >
                        {children}
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export { CommonLayout };
